module.exports = __webpack_public_path__ + "static/media/resilience.00eba653.png";